import { render, staticRenderFns } from "./storeIcon.vue?vue&type=template&id=0b289d0c&"
import script from "./storeIcon.vue?vue&type=script&lang=js&"
export * from "./storeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports